import { partnerDashboardAllowedReducer } from 'src/modules/partner-dashboard/reducers/partnerDashboardAllowedReducer';
import { partnerDashboardDataReducer } from 'src/modules/partner-dashboard/reducers/partnerDashboardDataReducer';
import { PartnerDashboardState } from 'src/modules/partner-dashboard/types/PartnerDashboardState';
import { chainReducers } from 'src/utils/chainReducers';

const defaultState: PartnerDashboardState = {
  data: null,
  allowed: false,
};

export const partnerDashboardReducer = chainReducers(defaultState, [
  partnerDashboardDataReducer,
  partnerDashboardAllowedReducer,
]);
